/**
 * Get the hostname for the Pillar development server.
 *
 * In the always-on RDE, it will have a proper DNS name. In local development, it
 * will default to `localhost`.
 *
 * @returns The hostname for the development server.
 */
function getDevHostname(): string {
	const envDns = __SERVER__
		? (globalThis.localDevContext?.RDE_DNS ?? process.env.RDE_DNS)
		: process.env.RDE_DNS;
	return typeof envDns === 'string' && envDns.trim() ? envDns.trim() : 'localhost';
}

function getProxyServerPort(): number {
	const serverPort = __SERVER__
		? (globalThis.localDevContext?.__PILLAR_PROXY_SERVER_PORT ??
			process.env.__PILLAR_PROXY_SERVER_PORT)
		: process.env.__PILLAR_PROXY_SERVER_PORT;

	return serverPort ? parseInt(serverPort, 10) : 9000;
}

export function getLocalUrl() {
	if (__SERVER__) {
		const overridden = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(globalThis as unknown as { localDevContext: { LOCAL_URL_OVERRIDE?: string } })
				.localDevContext?.LOCAL_URL_OVERRIDE;
		return (
			overridden ??
			`${(globalThis.localDevContext?.__PILLAR_ENABLE_HTTPS ?? process.env.__PILLAR_ENABLE_HTTPS === 'true') ? 'https' : 'http'}://${getDevHostname()}:${getProxyServerPort()}`
		);
	}
	return `${process.env.__PILLAR_ENABLE_HTTPS === 'true' ? 'https' : 'http'}://${getDevHostname()}:${getProxyServerPort()}`;
}
